import { useMutation } from "react-query";

import httpClient from "utils/http-client";
import { API_FORGOT_PASSWORD } from "consts";

export default function useForgotPassword(config) {
  return useMutation(
    ({ email }) => httpClient.post(API_FORGOT_PASSWORD, { email }),
    config
  );
}
